export default __webpack_public_path__ + "static/media/RoggoTransparent.ea1d419c.png";